interface TabContentProps {
  children?: React.ReactNode
  index: number
  name: string
  value: number
}

const TabContentContainer: React.FC<TabContentProps> = ({
  children,
  index,
  name,
  value,
  ...rest
}) => {
  return (
    <div
      aria-labelledby={`${name}-tab-${index}`}
      hidden={value !== index}
      id={`${name}-tabpanel-${index}`}
      role="tabpanel"
      {...rest}
    >
      {value === index && children}
    </div>
  )
}

export default TabContentContainer
